import React from 'react';
import './Header2.css';

const DEFAULT_SUBLOGO_MAP = {
  de: 'IHR ZUVERLÄSSIGER PARTNER für GRUPPENREISEN',
  en: 'YOUR RELIABLE PARTNER FOR GROUP TRAVEL',
  it: 'IL VOSTRO PARTNER AFFIDABILE PER I VIAGGI DI GRUPPO'
};

const Header2 = ({ language, onLanguageChange, content, contactMobile, contactEmail }) => {
  const sublogoText =
    content?.sublogo_text ||
    DEFAULT_SUBLOGO_MAP[language] ||
    DEFAULT_SUBLOGO_MAP.de;

  return (
    <header className="header2">
      <div className="header2-container">
        <div className="header2-brand">
          <img
            src="/allegrotours.gif"
            alt="AllegroTours"
            className="header2-logo"
            width="200"
            height="120"
            loading="lazy"
            decoding="async"
          />
          <p className="header2-sublogo">{sublogoText}</p>
        </div>
        
        <div className="header2-right">
          <nav className="header2-language">
            {[
              { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
              { code: 'en', label: 'English', flag: '🇬🇧' },
              { code: 'it', label: 'Italiano', flag: '🇮🇹' }
            ].map(lang => (
              <button
                key={lang.code}
                className={`header2-lang-btn ${language === lang.code ? 'active' : ''}`}
                onClick={() => onLanguageChange(lang.code)}
                aria-label={`Switch to ${lang.label}`}
              >
                <span className="flag">{lang.flag}</span>
                <span className="lang-text">{lang.code.toUpperCase()}</span>
              </button>
            ))}
          </nav>

          {(contactMobile || contactEmail) && (
            <div className="header2-contact">
              {contactMobile && <span>📱 {contactMobile}</span>}
              {contactEmail && (
                <span>
                  ✉️ <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header2;
